
























import {Component, Vue} from 'vue-property-decorator'
import {MetaInfo} from 'vue-meta'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import ContactForm from '@/components/contact/ContactForm.vue'

@Component({
  components: {AppFooter, ContactForm, Navbar},
})
export default class ContactUsView extends Vue {
  mounted() {
    window.scrollTo(0, 0)
  }

  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.contactUs'),
    }
  }
}
